import React, { useState, useEffect, useRef } from "react";
import styles from "../commanstyles.module.css";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckCircle,
    faEnvelope,
    faGlobe,
    faPhone,
    faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { getAboutTheCompany } from "../../../Services/APIrequests";
import { RotatingLines } from "react-loader-spinner";
import Aboutservices from "./Aboutservices";
import { FaFilter } from "react-icons/fa";
import parse from "html-react-parser";
import CopyButton from "../../ComapnyDetails/aboutthecompany/CopyButton";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaLock } from "react-icons/fa";
import { Link } from "react-router-dom";
import { formatIndianNumber } from "../../../Util/NumberConversion";

const Aboutcompany = ({
    companyInfo,
    setCompanyInfo,
    updatedRefreshTime,
    isLocked,
    unlockAPI,refreshLoading
}) => {
    const [showAllPhones, setShowAllPhones] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { cin } = useParams();
    const [activeTooltip, setActiveTooltip] = useState(null);
    const [leiLoading, setLeiLoading] = useState(false);
    const [leiTooltipOpen, setLeiTooltipOpen] = useState(false);
    const [leiTooltipData, setLeiTooltipData] = useState(null);
    const [leiTooltipPos, setLeiTooltipPos] = useState({ left: 0, top: 0 });
    const leiButtonRef = useRef(null);
    const leiTooltipRef = useRef(null);
    const [filterStatus, setFilterStatus] = useState([]);
    const [availableStatuses, setAvailableStatuses] = useState([]);
    const [selectedYearStructure, setSelectedYearStructure] = useState("");
    const [selectedYearActivities, setSelectedYearActivities] = useState("");
    const MySwal = withReactContent(Swal);

    const toggleTooltip = (type) => {
        if (activeTooltip === type) {
            setActiveTooltip(null);
        } else {
            setActiveTooltip(type);
        }
    };

    // utils/format.js (or inside your component file at the top)
    const formatRupees = (value) => {
        if (!value || isNaN(value)) return "0.00";
        return Number(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const LockOverlay = () => {
        const handleUnlockClick = () => {
            MySwal.fire({
                title: "This section is locked",
                text: "Unlock with credits to view full data.",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    // Optional: redirect or unlock data
                    // window.location.href = "/kohere/mycredits";
                }
            });
        };

        return (
            <div
                className={styles.lockOverlay}
                onClick={unlockAPI}
                style={{ cursor: "pointer" }}>
                <FaLock className={styles.lockIcon} />
                <p>Click to unlock this section</p>
            </div>
        );
    };

    const handleUnlockField = (field) => {
        if (typeof unlockAPI === "function") {
            try {
                unlockAPI(field);
            } catch (err) {
                console.error("unlockAPI error:", err);
            }
        } else {
            MySwal.fire({
                title: "This value is locked",
                text: "Unlock with credits to view this value.",
                icon: "info",
                confirmButtonText: "Ok",
            });
        }
    };

    const handleFilterChange = (e, value) => {
        // Handle filter changes for status only
        if (e.target.checked) {
            setFilterStatus((prev) => [...prev, value]);
        } else {
            setFilterStatus((prev) => prev.filter((item) => item !== value));
        }
    };

    useEffect(() => {
        const fetchCompanyInfo = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getAboutTheCompany(cin);

                if (response?.data) {
                    const phoneNumbers =
                        response.data.aboutTheCompany?.PhoneNumbers || [];

                    setCompanyInfo({
                        ...response.data.aboutTheCompany,
                        PhoneNumbers: phoneNumbers,
                        principalBusinessActivities:
                            response.data.principalBusinessActivities || [],
                        companyStructureRelatedCorporated:
                            response.data.companyStructureRelatedCorporated ||
                            [],
                    });

                    const statuses =
                        response.data.companyStructureRelatedCorporated?.map(
                            (item) => item.category
                        ) || [];
                    setAvailableStatuses([...new Set(statuses)]);

                    const structureYears = [
                        ...new Set(
                            (
                                response.data
                                    .companyStructureRelatedCorporated || []
                            )
                                .map((item) => item.financialYear)
                                .filter(Boolean)
                        ),
                    ].sort((a, b) => b - a);
                    setSelectedYearStructure(structureYears[0] || "");

                    const activityYears = [
                        ...new Set(
                            (
                                response.data.principalBusinessActivities ||
                                []
                            )
                                .map((item) => item.financialYear)
                                .filter(Boolean)
                        ),
                    ].sort((a, b) => b - a);
                    setSelectedYearActivities(activityYears[0] || "");
                } else {
                    setCompanyInfo(null);
                }
            } catch (err) {
                console.error("Error fetching data:", err);
                setError("Company Loading...");
            } finally {
                setLoading(false);
            }
        };
        if(refreshLoading==false){

        fetchCompanyInfo();
        }
    }, [cin, updatedRefreshTime,refreshLoading]); // ✅ refetch when cin OR refresh time changes
    // Close tooltip when clicking outside
    useEffect(() => {
        const handleDocClick = (e) => {
            if (!leiTooltipOpen) return;
            const btn = leiButtonRef.current;
            const tip = leiTooltipRef.current;
            if (btn && btn.contains(e.target)) return;
            if (tip && tip.contains(e.target)) return;
            setLeiTooltipOpen(false);
        };

        document.addEventListener("mousedown", handleDocClick);
        return () => document.removeEventListener("mousedown", handleDocClick);
    }, [leiTooltipOpen]);

    if (loading) {
        return (
            <div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}>
                    <RotatingLines
                        height="80"
                        width="80"
                        color={
                            getComputedStyle(
                                document.documentElement
                            ).getPropertyValue("--PrimaryColor") || "#4fa94d"
                        }
                        ariaLabel="circles-loading"
                        visible={true}
                    />
                </div>
            </div>
        );
    }

    if (error) {
        return <div><h2>{error}</h2></div>;
    }

    if (!companyInfo) {
        return <div>No company information available.</div>;
    }

    // Modified companyData array to handle LLP companies
    const companyData =
        companyInfo?.Company_Class === "LLP"
            ? [
                  {
                      details: [
                          {
                              label:
                                  companyInfo?.Company_Class === "LLP"
                                      ? "LLPIN"
                                      : companyInfo?.Company_Class === null ||
                                        companyInfo?.Company_Class === undefined
                                      ? "CIN / LLPIN"
                                      : "CIN",
                              value:
                                  companyInfo?.CIN || companyInfo?.LLPIN || "-",
                          },
                          {
                              label: "ROC Name",
                              value:
                                  companyInfo?.Registrar_Of_Companies ||
                                  companyInfo?.ROC_Code ||
                                  "-",
                          },
                          {
                              label: "Date of Incorporation",
                              value:
                                  companyInfo?.DateOfRegistration ||
                                  companyInfo?.Date_of_Incorporation
                                      ? new Date(
                                            companyInfo?.DateOfRegistration ||
                                                companyInfo?.Date_of_Incorporation
                                        ).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                      : "",
                          },

                          // 🔒 Only visible when unlocked
                          !isLocked && {
                              label: "Main Division",
                              value: companyInfo?.main_division || "-",
                          },
                          !isLocked && {
                              label: "Description of Main Division",
                              value:
                                  companyInfo?.description_of_main_division ||
                                  "-",
                          },
                          !isLocked && {
                              label: "Annual Return Filed",
                              value: companyInfo?.annual_Return_filed
                                  ? new Date(
                                        companyInfo.annual_Return_filed
                                    ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })
                                  : "-",
                          },
                          !isLocked && {
                              label: "Solvency Filed",
                              value: companyInfo?.Solvency_filed
                                  ? new Date(
                                        companyInfo.Solvency_filed
                                    ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })
                                  : "-",
                          },
                          !isLocked && {
                              label: "Previous Firm",
                              value: companyInfo?.previous_firm || "",
                          },
                          !isLocked && {
                              label: "PAN",
                              value: companyInfo?.PanCard,
                              // icon: faCheckCircle,
                          },
                      ].filter(Boolean),
                  },
                  {
                      details: [
                          {
                              label: "Email Id",
                              value: companyInfo?.EmailIds || [],
                              icon: faEnvelope,
                          },
                          {
                              label: "Phone",
                              value: companyInfo?.PhoneNumbers || [],
                              icon: faPhone,
                          },
                          {
                              label: "Registered Office Address",
                              value:
                                  companyInfo?.RegisteredOfficeAddress ||
                                  companyInfo?.Registered_Address ||
                                  "-",
                              icon: faMapMarkerAlt,
                          },
                          !isLocked && {
                              label: "GST",
                              // Keep GST as an array so each GST can be copied separately
                              value:
                                  companyInfo?.GSTIN &&
                                  companyInfo?.GSTIN.length > 0
                                      ? companyInfo?.GSTIN.map(
                                            (item) => item?.GSTIN
                                        ).filter(Boolean)
                                      : [],
                              icon: faCheckCircle,
                          },
                      ],
                  },
              ]
            : [
                  {
                      details: [
                          {
                              label:
                                  companyInfo?.Company_Class === "LLP"
                                      ? "LLPIN"
                                      : companyInfo?.Company_Class
                                      ? "CIN"
                                      : "CIN / LLPIN",
                              value:
                                  companyInfo?.CIN || companyInfo?.LLPIN || "-",
                          },
                          {
                              label: "Registration Number",
                              value: companyInfo?.RegistrationNumber,
                          },
                          {
                              label: "ROC Name",
                              value: companyInfo?.Registrar_Of_Companies,
                          },
                          {
                              label: "Date of Incorporation",
                              value: companyInfo?.DateOfRegistration
                                  ? new Date(
                                        companyInfo.DateOfRegistration
                                    ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })
                                  : "",
                          },
                          {
                              label: "Date of last AGM",
                              value: companyInfo.DateofLastAGM
                                  ? new Date(
                                        companyInfo?.DateofLastAGM
                                    ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })
                                  : "",
                          },
                          {
                              label: "Company Status",
                              value: companyInfo?.Company_Status,
                          },
                          !isLocked && {
                              label: "PAN",
                              value: companyInfo?.PanCard,
                              // icon: faCheckCircle,
                          },
                          !isLocked && {
                              label: "Name of the Auditor or Auditor's Firm",
                              value: companyInfo?.AuditorName,
                              // icon: faCheckCircle,
                          },
                          !isLocked && {
                              label: "Name of the Secretarial Auditor or Auditor's Firm",
                              value: companyInfo?.AuditorFirmName,
                              // icon: faCheckCircle,
                          },
                          !isLocked && {
                              label: "Name of the Cost Auditor/ Auditor's firm",
                              value: companyInfo?.costAuditorName,
                              // icon: faCheckCircle,
                          },
                      ],
                  },
                  {
                      details: [
                          {
                              label: "Category of Company",
                              value: companyInfo?.Company_Category,
                          },
                          {
                              label: "Subcategory of the Company",
                              value: companyInfo?.Sub_Category,
                          },
                          {
                              label: "Class of Company",
                              value: companyInfo?.Company_Class,
                          },
                          {
                              label: "Date of Balance Sheet",
                              value: companyInfo?.dateOfBalanceSheet
                                  ? new Date(
                                        companyInfo?.dateOfBalanceSheet
                                    ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })
                                  : "",
                          },

                          {
                              label: "ACTIVE compliance",
                              value: companyInfo?.activeCompliance,
                          },

                          !isLocked && {
                              label: "GST",
                              // Keep GST as an array so each GST can be copied separately
                              value:
                                  companyInfo?.GSTNumber &&
                                  companyInfo?.GSTNumber.length > 0
                                      ? companyInfo?.GSTNumber.filter(Boolean)
                                      : companyInfo?.GSTIN &&
                                        companyInfo?.GSTIN.length > 0
                                      ? companyInfo?.GSTIN.map(
                                            (item) => item?.GSTIN
                                        ).filter(Boolean)
                                      : [],
                              // icon: faCheckCircle,
                          },

                          !isLocked && {
                              label: "PF Number",
                              value:
                                  companyInfo?.pfNumber ||
                                  (companyInfo?.EPFO &&
                                  companyInfo?.EPFO.length > 0
                                      ? companyInfo?.EPFO.map(
                                            (item) => item?.establishmentId
                                        ).filter(Boolean)
                                      : []),
                              // icon: faCheckCircle,
                          },
                          !isLocked && {
                              label: "LEI Number",
                              value: companyInfo?.LEINumber,
                              // icon: faCheckCircle,
                          },
                      ].filter(Boolean),
                  },
                  {
                      details: [
                          {
                              label: "Listed in Stock Exchange(s)",
                              value: companyInfo?.listedInStockExchange,
                              icon: faCheckCircle,
                          },
                          {
                              label: "Registered Office Address",
                              value: companyInfo?.RegisteredOfficeAddress,
                              icon: faMapMarkerAlt,
                          },
                          {
                              label: "Business Address",
                              value: companyInfo?.Company_Address,
                              icon: faMapMarkerAlt,
                          },
                          {
                              label: "Email Id",
                              value: companyInfo?.EmailIds || [],
                              icon: faEnvelope,
                          },

                          !isLocked && {
                              label: "Website",
                              value: companyInfo?.WebsiteURL,
                              icon: faGlobe,
                          },

                          !isLocked && {
                              label: "Google Maps",
                              value: companyInfo?.Googlemaps_Link,
                              icon: faMapMarkerAlt,
                              isLink: true,
                          },
                          !isLocked && {
                              label: "Phone",
                              value: companyInfo?.PhoneNumbers || [],
                              icon: faPhone,
                          },

                          !isLocked && {
                              label: "Name of the Registrar and Transfer Agent",
                              value: companyInfo?.nameOfRegistrar,
                              icon: faCheckCircle,
                          },
                      ].filter(Boolean),
                  },
              ];

    const renderPhoneNumbers = (phones) => {
        if (!phones || phones.length === 0) {
            return <span>-</span>;
        }

        const phoneList = showAllPhones ? phones : phones.slice(0, 3);

        return (
            <>
                {phoneList.map((phone, index) => (
                    <div key={index}>
                        <span>{phone || "-"}</span>
                    </div>
                ))}
                {phones.length > 3 && (
                    <button
                        onClick={() => setShowAllPhones(!showAllPhones)}
                        className={styles.readMoreButton}>
                        {showAllPhones ? "Show Less" : "Read More"}
                    </button>
                )}
            </>
        );
    };

    const renderEmails = (emails) => {
        if (!emails || emails.length === 0) {
            return <span>-</span>;
        }

        return (
            <>
                {emails.map((email, index) => (
                    <div key={index}>
                        <a href={`mailto:${email}`}>{email}</a>
                    </div>
                ))}
            </>
        );
    };

    const renderDetailValue = (detail) => {
        if (detail.isLink && detail.value !== "-") {
            return (
                <div className={styles.copyableValue}>
                    <a
                        href={detail.value}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.detail_link}>
                        {detail?.label === "Google Maps"
                            ? "Office Address Link"
                            : detail?.value || "-"}
                    </a>
                    <CopyButton text={detail.value} />
                </div>
            );
        }

        if (Array.isArray(detail?.value)) {
            if (detail?.label === "Phone") {
                return (
                    <>
                        {renderPhoneNumbers(detail?.value)}
                        {detail?.value.length > 0 && (
                            <CopyButton text={detail.value.join(", ")} />
                        )}
                    </>
                );
            }
            if (detail?.label === "Email Id") {
                return (
                    <>
                        {renderEmails(detail?.value)}
                        {detail?.value.length > 0 && (
                            <CopyButton text={detail.value.join(", ")} />
                        )}
                    </>
                );
            }
            // Render each array item with its own copy button so values
            // like multiple GSTINs can be copied individually.
            return (
                <>
                    {detail?.value.map((val, idx) => (
                        <div key={idx} className={styles.copyRow}>
                            <span>{val || "-"}</span>
                            {val && <CopyButton text={val} />}
                        </div>
                    ))}
                </>
            );
        }

        return (
            <div className={styles.copyableValue}>
                {detail?.value || "-"}
                {detail?.value && detail.value !== "-" && (
                    <>
                        <CopyButton text={detail.value} />
                        {/* Show an info button for LEI Number to fetch details from API */}
                    </>
                )}
            </div>
        );
    };

    // Fetch LEI details from API and show modal
    // Fetch LEI details and show a small tooltip (on hover/focus)
    const handleLeiClick = async (lei, event) => {
        const leanum = (lei || "").toString().trim();
        if (!leanum || leanum === "-") {
            setLeiTooltipData({ error: "LEI number not available." });
            setLeiTooltipOpen(true);
            return;
        }

        // position tooltip near event target (centered above)
        if (event && event.currentTarget) {
            const rect = event.currentTarget.getBoundingClientRect();
            setLeiTooltipPos({
                left: rect.left + rect.width / 2,
                top: rect.top + window.scrollY,
            });
        }

        try {
            setLeiLoading(true);
            setLeiTooltipOpen(true);
            setLeiTooltipData(null);
            const url = `${process.env.REACT_APP_BASE_URL}tabData/getLei/${encodeURIComponent(
                leanum
            )}`;
            const res = await fetch(url);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();

            if (data?.Status === 1 && data?.leiData) {
                setLeiTooltipData(data.leiData);
            } else {
                setLeiTooltipData({ error: "No LEI data found." });
            }
        } catch (err) {
            console.error("Error fetching LEI:", err);
            setLeiTooltipData({ error: "Failed to fetch LEI details." });
        } finally {
            setLeiLoading(false);
        }
    };

    // Financial years available for the Holding/Subsidiary/Associate table
    const structureYears = [
        ...new Set(
            (companyInfo?.companyStructureRelatedCorporated || [])
                .map((item) => item.financialYear)
                .filter(Boolean)
        ),
    ].sort((a, b) => b - a);

    // Financial years available for the Principal Business Activities table
    const activityYears = [
        ...new Set(
            (companyInfo?.principalBusinessActivities || [])
                .map((item) => item.financialYear)
                .filter(Boolean)
        ),
    ].sort((a, b) => b - a);

    // Filter companyStructureRelatedCorporated by the selected filterStatus and financial year
    const filteredCompanyStructure =
        companyInfo?.companyStructureRelatedCorporated?.filter(
            (activity) =>
                (filterStatus.length === 0 ||
                    filterStatus.includes(activity.category)) &&
                (!selectedYearStructure ||
                    activity.financialYear === selectedYearStructure)
        );

    // Filter principalBusinessActivities by the selected financial year
    const filteredPrincipalBusinessActivities =
        companyInfo?.principalBusinessActivities?.filter(
            (activity) =>
                !selectedYearActivities ||
                activity.financialYear === selectedYearActivities
        );

    return (
        <div className={styles.about_container}>
            <div className={styles.about_price_container}>
                {companyInfo?.Company_Class === "LLP" ? (
                    <>
                        <div className={styles.about_body_pricebox1}>
                            <p className={styles.about_body_text}>
                                Total Obligation Of Contribution
                            </p>
                            <p className={styles.about_body_pricetext}>
                                ₹{" "}
                                {companyInfo?.Total_Obligation_of_Contribution ||
                                    companyInfo?.Authorized_Capital ||
                                    "0"}
                            </p>
                        </div>

                        <div className={styles.about_body_pricebox1}>
                            <p className={styles.about_body_text}>
                                Number of Partners
                            </p>
                            <p
                                className={styles.about_body_pricetext}
                                style={{ color: "teal" }}>
                                {companyInfo?.number_of_Partners || "0"}
                            </p>
                        </div>
                        <div className={styles.about_body_pricebox1}>
                            <p className={styles.about_body_text}>
                                Number of Designated Partners
                            </p>
                            <p
                                className={styles.about_body_pricetext}
                                style={{ color: "teal" }}>
                                {companyInfo?.number_of_Designated_Partners ||
                                    "0"}
                            </p>
                        </div>
                        <div className={styles.about_body_pricebox1}>
                            <p className={styles.about_body_text}>LLP STATUS</p>
                            <p
                                className={styles.about_body_pricetext}
                                style={{ color: "green", fontWeight: "bold" }}>
                                {companyInfo?.Company_Status ||
                                    companyInfo?.LLP_Status ||
                                    "-"}
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.about_body_pricebox}>
                            <p className={styles.about_body_text}>
                                Authorised Capital (Rs)
                            </p>
                            <p className={styles.about_body_pricetext}>
                                ₹{" "}
                                {formatIndianNumber(companyInfo?.Authorized_Capital)}
                            </p>
                        </div>

                        <div className={styles.about_body_pricebox}>
                            <p className={styles.about_body_text}>
                                Paid up Capital (Rs)
                            </p>
                            <p className={styles.about_body_pricetext}>
                                ₹ {formatIndianNumber(companyInfo?.PaidUp_Capital)}
                            </p>
                        </div>

                        <div
                            className={styles.sectionWrapper}
                            style={{
                                display: "flex",
                                gap: 8,
                                alignItems: "stretch",
                            }}>
                            <div className={styles.about_body_pricebox}>
                                <p className={styles.about_body_text}>
                                    Turnover (Rs)
                                </p>
                                <div className={styles.priceBoxInner}>
                                    <p
                                        className={`${
                                            styles.about_body_pricetext
                                        } ${isLocked ? styles.priceBlur : ""}`}>
                                        {isLocked
                                            ? "—"
                                            : `₹ ${formatRupees(
                                                  companyInfo?.turnover
                                              )}`}
                                    </p>
                                    {isLocked && (
                                        <button
                                            className={styles.priceOverlay}
                                            onClick={() =>
                                                handleUnlockField("turnover")
                                            }
                                            aria-label="unlock turnover">
                                            <FaLock />
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className={styles.about_body_pricebox}>
                                <p className={styles.about_body_text}>
                                    Net worth (Rs)
                                </p>
                                <div className={styles.priceBoxInner}>
                                    <p
                                        className={`${
                                            styles.about_body_pricetext
                                        } ${isLocked ? styles.priceBlur : ""}`}>
                                        {isLocked
                                            ? "—"
                                            : `₹ ${formatRupees(
                                                  companyInfo?.netWorth
                                              )}`}
                                    </p>
                                    {isLocked && (
                                        <button
                                            className={styles.priceOverlay}
                                            onClick={() =>
                                                handleUnlockField("netWorth")
                                            }
                                            aria-label="unlock net worth">
                                            <FaLock />
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className={styles.about_body_pricebox}>
                                <p className={styles.about_body_text}>
                                    Profit after Tax (Rs)
                                </p>
                                <div className={styles.priceBoxInner}>
                                    <p
                                        className={`${
                                            styles.about_body_pricetext
                                        } ${isLocked ? styles.priceBlur : ""}`}>
                                        {isLocked
                                            ? "—"
                                            : companyInfo?.Profit_after_Tax
                                            ? `₹ ${formatRupees(companyInfo?.Profit_after_Tax)}`
                                            : "-"}
                                    </p>
                                    {isLocked && (
                                        <button
                                            className={styles.priceOverlay}
                                            onClick={() =>
                                                handleUnlockField(
                                                    "profitAfterTax"
                                                )
                                            }
                                            aria-label="unlock profit after tax">
                                            <FaLock />
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className={styles.about_body_pricebox}>
                                <p className={styles.about_body_text}>EPS</p>
                                <div className={styles.priceBoxInner}>
                                    <p
                                        className={`${
                                            styles.about_body_pricetext
                                        } ${isLocked ? styles.priceBlur : ""}`}>
                                        {isLocked
                                            ? "—"
                                            : companyInfo?.EPS
                                            ? formatRupees(companyInfo?.EPS)
                                            : "-"}
                                    </p>
                                    {isLocked && (
                                        <button
                                            className={styles.priceOverlay}
                                            onClick={() =>
                                                handleUnlockField("eps")
                                            }
                                            aria-label="unlock eps">
                                            <FaLock />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <div style={{ position: "relative" }}>
                <div className={styles.gridContainer}>
                    {companyData.map((section, index) => (
                        <div key={index} className={styles.gridItem}>
                            {section.heading && (
                                <h4 className={styles.sectionHeading}>
                                    {section.heading}
                                </h4>
                            )}

                            {section.details.map((detail, idx) => {
                                const value =
                                    typeof detail.value === "string"
                                        ? detail.value.trim()
                                        : detail.value;

                                const isEmptyValue =
                                    value === null ||
                                    value === undefined ||
                                    value === "" ||
                                    value === "null" ||
                                    value === "NA" ||
                                    (Array.isArray(value) &&
                                        value.length === 0);

                                if (isEmptyValue) return null;

                                return (
                                    <div key={idx} className={styles.detailRow}>
                                        {detail.icon && (
                                            <FontAwesomeIcon
                                                icon={detail.icon}
                                                style={{ cursor: "default" }}
                                                className={styles.detailIcon}
                                            />
                                        )}
                                        <div className={styles.detailContent}>
                                            <span
                                                className={styles.detailLabel}>
                                                {detail.label}{" "}
                                                {detail?.label ===
                                                    "LEI Number" && (
                                                    <button
                                                        ref={leiButtonRef}
                                                        className={
                                                            styles.leiInfoButton
                                                        }
                                                        onClick={async (e) => {
                                                            // toggle: if already open close, else open and fetch
                                                            if (
                                                                leiTooltipOpen
                                                            ) {
                                                                setLeiTooltipOpen(
                                                                    false
                                                                );
                                                            } else {
                                                                await handleLeiClick(
                                                                    detail.value,
                                                                    e
                                                                );
                                                            }
                                                        }}
                                                        aria-label="LEI info button"
                                                        aria-expanded={
                                                            leiTooltipOpen
                                                        }
                                                        disabled={leiLoading}>
                                                        {leiLoading
                                                            ? "..."
                                                            : "i"}
                                                    </button>
                                                )}
                                            </span>
                                            <span
                                                className={
                                                    styles.detailSeparator
                                                }>
                                                :
                                            </span>
                                            <span
                                                className={styles.detailValue}>
                                                {renderDetailValue(detail)}
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>

                {/* LEI tooltip (hover) */}
                {leiTooltipOpen && (
                    <div
                        role="tooltip"
                        ref={leiTooltipRef}
                        style={{
                            position: "fixed",
                            left: leiTooltipPos.left,
                            top: leiTooltipPos.top - 10,
                            transform: "translate(-50%, -100%)",
                            width: 300,
                            border: "1px solid #e0e0e0",
                            background: "#fff",
                            padding: 10,
                            borderRadius: 6,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                            zIndex: 2000,
                        }}>
                        {leiLoading && <div>Loading...</div>}
                        {!leiLoading && leiTooltipData?.error && (
                            <div style={{ color: "#666" }}>
                                {leiTooltipData.error}
                            </div>
                        )}
                        {!leiLoading &&
                            leiTooltipData &&
                            !leiTooltipData.error && (
                                <div
                                    style={{ textAlign: "left", fontSize: 13 }}>
                                    <div style={{ marginBottom: 6 }}>
                                        <strong>LEI:</strong>{" "}
                                        {leiTooltipData.lei || "-"}
                                    </div>
                                    <div style={{ marginBottom: 6 }}>
                                        <strong>Issuer:</strong>{" "}
                                        {leiTooltipData.leiIssuer || "-"}
                                    </div>
                                    <div style={{ marginBottom: 6 }}>
                                        <strong>Status:</strong>{" "}
                                        {leiTooltipData.leiStatus || "-"}
                                    </div>
                                    <div style={{ marginBottom: 6 }}>
                                        <strong>Registration Date:</strong>{" "}
                                        {leiTooltipData.registrationDate
                                            ? new Date(
                                                  leiTooltipData.registrationDate
                                              ).toLocaleDateString("en-GB")
                                            : "-"}
                                    </div>
                                    <div style={{ marginBottom: 6 }}>
                                        <strong>Next Renewal:</strong>{" "}
                                        {leiTooltipData.nextRenewal
                                            ? new Date(
                                                  leiTooltipData.nextRenewal
                                              ).toLocaleDateString("en-GB")
                                            : "-"}
                                    </div>
                                    <div style={{ marginBottom: 6 }}>
                                        <strong>Last Update:</strong>{" "}
                                        {leiTooltipData.lastUpdate
                                            ? new Date(
                                                  leiTooltipData.lastUpdate
                                              ).toLocaleDateString("en-GB")
                                            : "-"}
                                    </div>
                                    <div style={{ marginBottom: 6 }}>
                                        <strong>Registration Authority:</strong>{" "}
                                        {leiTooltipData.registrationAuthority ||
                                            "-"}
                                    </div>
                                </div>
                            )}
                    </div>
                )}
            </div>

            <div className={styles.about_container_content}>
                <div className={styles.aboutCompanyContainer}>
                    {/* <h6>ABOUT THE COMPANY ( Main Objectives of the Company )</h6> */}
                    <h6>
                        ABOUT THE{" "}
                        {companyInfo?.Company_Class === "LLP"
                            ? "LLP"
                            : "COMPANY"}
                        ( Main Objectives of the{" "}
                        {companyInfo?.Company_Class === "LLP"
                            ? "LLP"
                            : "Company"}{" "}
                        )
                    </h6>

                    <div
                        className={`${styles.sectionWrapper} ${
                            isLocked ? styles.locked : ""
                        }`}>
                        {isLocked && <LockOverlay />}
                        {/* About Company */}
                        <div className={styles.aboutBox}>
                            {companyInfo?.AboutCompany != "NA" &&
                                companyInfo?.AboutCompany && (
                                    <p>{parse(companyInfo.AboutCompany)}</p>
                                )}
                        </div>
                        {/* Company Objectives */}
                        <div className={styles.aboutBox}>
                            {companyInfo?.companyObjectives && (
                                <p>{parse(companyInfo.companyObjectives)}</p>
                            )}
                        </div>
                        {!companyInfo?.companyObjectives &&
                            !companyInfo?.AboutCompany && (
                                <div className={styles.aboutBox}>
                                    <p className={styles.noData}>
                                        No information provided.
                                    </p>
                                </div>
                            )}
                    </div>
                </div>

                <div className={styles.Aboutcompanytable}>
                    <h6 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span>
                            PRINCIPAL BUSINESS ACTIVITIES OF THE{" "}
                            {companyInfo?.Company_Class === "LLP"
                                ? "LLP"
                                : "COMPANY"}
                        </span>
                        {activityYears.length > 0 && (
                            <div className={styles.yearSelectContainer}>
                                <select
                                    id="year-select-activities"
                                    value={selectedYearActivities}
                                    onChange={(e) =>
                                        setSelectedYearActivities(
                                            e.target.value
                                        )
                                    }>
                                    {activityYears.map((year) => (
                                        <option key={year} value={year}>
                                            {parseInt(year) - 1} - {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </h6>

                    <div
                        className={`${styles.sectionWrapper} ${
                            isLocked ? styles.locked : ""
                        }`}>
                        {isLocked && <LockOverlay />}
                        <table className={styles.commantable}>
                            <thead className={styles.table_header}>
                                <tr className={styles.tableHeaderRow}>
                                    <th className={styles.tableHeader}>S.No</th>
                                    <th className={styles.tableHeader}>
                                        Main Activity group code
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Description of Main Activity group
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Business Activity Code
                                    </th>
                                    {companyInfo?.Company_Class !== "LLP" && (
                                        <>
                                            <th className={styles.tableHeader}>
                                                Description of Business Activity
                                            </th>
                                            <th className={styles.tableHeader}>
                                                % of turnover of the{" "}
                                                {companyInfo?.Company_Class ===
                                                "LLP"
                                                    ? "LLP"
                                                    : "Company"}
                                            </th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPrincipalBusinessActivities &&
                                filteredPrincipalBusinessActivities.length >
                                    0 ? (
                                    filteredPrincipalBusinessActivities.map(
                                        (activity, index) => (
                                            <tr
                                                key={index}
                                                className={styles.tableRow}>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {index + 1}
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {
                                                        activity.mainActivityGroupCode
                                                    }
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {
                                                        activity.mainActivity_description
                                                    }
                                                </td>
                                                <td
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    {
                                                        activity.businessActivityCode
                                                    }
                                                </td>
                                                {companyInfo?.Company_Class !==
                                                    "LLP" && (
                                                    <>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {
                                                                activity.businessActivity_description
                                                            }
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {
                                                                activity.turnover_percentage
                                                            }
                                                        </td>
                                                    </>
                                                )}
                                            </tr>
                                        )
                                    )
                                ) : (
                                    <tr className={styles.tableRow}>
                                        <td
                                            colSpan={
                                                companyInfo?.Company_Class ===
                                                "LLP"
                                                    ? 4
                                                    : 6
                                            }
                                            className={styles.tableCell}>
                                            No principal business activities
                                            available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={styles.Aboutcompanytable}>
                    <h6 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span>
                            {companyInfo?.Company_Class === "LLP"
                                ? "NAME OF THE CONTRIBUTORS AND PERCENTAGE OF CONTRIBUTION - LLP COMPANIES"
                                : "NAME OF HOLDING, SUBSIDIARY AND ASSOCIATE COMPANIES (INCLUDING JOINT VENTURES)"}
                        </span>
                        {companyInfo?.Company_Class !== "LLP" &&
                            structureYears.length > 0 && (
                                <div className={styles.yearSelectContainer}>
                                    <select
                                        id="year-select-structure"
                                        value={selectedYearStructure}
                                        onChange={(e) =>
                                            setSelectedYearStructure(
                                                e.target.value
                                            )
                                        }>
                                        {structureYears.map((year) => (
                                            <option key={year} value={year}>
                                                {parseInt(year) - 1} - {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                    </h6>

                    <div
                        className={`${styles.sectionWrapper} ${
                            isLocked ? styles.locked : ""
                        }`}>
                        {isLocked && <LockOverlay />}
                        <div className={styles.table_subcontainer_about}>
                            <table className={styles.commantable}>
                                <thead className={styles.table_header}>
                                    {companyInfo?.Company_Class === "LLP" ? (
                                        <tr className={styles.tableHeaderRow}>
                                            <th className={styles.tableHeader}>
                                                S.No
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Name of the Contributor
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Obligation of Contribution
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Contribution Received
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Designation
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Percentage of Contribution
                                            </th>
                                        </tr>
                                    ) : (
                                        <tr className={styles.tableHeaderRow}>
                                            <th className={styles.tableHeader}>
                                                S.No
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Name of the company
                                            </th>
                                            <th className={styles.tableHeader}>
                                                CIN / FCRN
                                            </th>
                                            <th
                                                className={styles.tableHeader}
                                                id={
                                                    styles.tableheader_filtericon
                                                }>
                                                <span>
                                                    Holding/
                                                    Subsidiary/Associate/ Joint
                                                    Venture
                                                </span>
                                                <span>
                                                    {availableStatuses.length >
                                                        1 && ( // only show filter if more than 1
                                                        <FaFilter
                                                            className={
                                                                styles.filterIcon
                                                            }
                                                            onClick={() =>
                                                                toggleTooltip(
                                                                    "status"
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </span>

                                                <div
                                                    className={
                                                        styles.filterIconContainer
                                                    }>
                                                    {activeTooltip ===
                                                        "status" && (
                                                        <div
                                                            className={
                                                                styles.tooltip1
                                                            }>
                                                            <div
                                                                className={
                                                                    styles.filterOptions
                                                                }
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    flexDirection:
                                                                        "column",
                                                                    gap: "0.3rem",
                                                                }}>
                                                                {availableStatuses.map(
                                                                    (
                                                                        status
                                                                    ) => (
                                                                        <label
                                                                            style={{
                                                                                fontWeight: 500,
                                                                                color: "black",
                                                                            }}
                                                                            key={
                                                                                status
                                                                            }>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={filterStatus.includes(
                                                                                    status
                                                                                )}
                                                                                onChange={(
                                                                                    e
                                                                                ) =>
                                                                                    handleFilterChange(
                                                                                        e,
                                                                                        status
                                                                                    )
                                                                                }
                                                                            />
                                                                            {
                                                                                status
                                                                            }
                                                                        </label>
                                                                    )
                                                                )}
                                                                <button
                                                                    style={{
                                                                        borderRadius:
                                                                            "10px",
                                                                        background:
                                                                            "#d32f2f",
                                                                        color: "white",
                                                                        width: "100%",
                                                                        border: "none",
                                                                        padding:
                                                                            "0.5rem 0",
                                                                    }}
                                                                    className={
                                                                        styles.closeTooltipButton
                                                                    }
                                                                    onClick={() =>
                                                                        setActiveTooltip(
                                                                            null
                                                                        )
                                                                    }>
                                                                    Close
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </th>

                                            <th className={styles.tableHeader}>
                                                % of shares held
                                            </th>
                                        </tr>
                                    )}
                                </thead>

                                <tbody>
                                    {companyInfo?.Company_Class === "LLP" ? (
                                        companyInfo?.contributors?.length >
                                        0 ? (
                                            companyInfo.contributors.map(
                                                (contributor, index) => (
                                                    <tr
                                                        key={index}
                                                        className={
                                                            styles.tableRow
                                                        }>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {index + 1}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {contributor.name}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {
                                                                contributor.obligationOfContribution
                                                            }
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {
                                                                contributor.contributionReceived
                                                            }
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {
                                                                contributor.designation
                                                            }
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {
                                                                contributor.percentageOfContribution
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                        ) : (
                                            <tr className={styles.tableRow}>
                                                <td
                                                    colSpan="6"
                                                    className={
                                                        styles.tableCell
                                                    }>
                                                    No contributors available
                                                </td>
                                            </tr>
                                        )
                                    ) : filteredCompanyStructure.length > 0 ? (
                                        filteredCompanyStructure.map(
                                            (activity, index) => (
                                                <tr
                                                    key={index}
                                                    className={styles.tableRow}>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {index + 1}
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {
                                                            activity.corporate_name
                                                        }
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {activity.cin_fcrn}
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {activity.category}
                                                    </td>
                                                    <td
                                                        className={
                                                            styles.tableCell
                                                        }>
                                                        {
                                                            activity.Equity_Shareholding
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    ) : (
                                        <tr className={styles.tableRow}>
                                            <td
                                                colSpan="5"
                                                className={styles.tableCell}>
                                                No Subsidiary Companies were there.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className={styles.Aboutcompanytable}>
                    <h5>
                        LOOKING TO SECURE ADDITIONAL FUNDS TO EXPAND YOUR
                        BUSINESS
                    </h5>

                    <div
                        className={`${styles.sectionWrapper} ${
                            isLocked ? styles.locked : ""
                        }`}>
                        {isLocked && <LockOverlay />}
                        <Aboutservices />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Aboutcompany;
